import React, { useRef } from 'react';
import Plot from 'react-plotly.js';
import './RadarChart.css';

function RadarChart({ preferences, positions, exclusions, results, onClose }) {
  const containerRef = useRef(null);

  const categories = ['Spice', 'Sour', 'Sweet', 'Bitter', 'Umami', 'Salt', 'Fatty'];
  
  // Normalize values from 1-64 scale to 1-10 scale
  const normalize = (value, totalItems) => {
    return (value / totalItems) * 9 + 1;
  };

  const totalItems = 65; // Default, can be fetched if needed
  const userValues = categories.map(cat => parseFloat(preferences[cat] || 5));

  // Create plot data
  const data = [
    {
      type: 'scatterpolar',
      r: userValues,
      theta: categories,
      fill: 'toself',
      name: 'Your Input',
      fillcolor: 'rgba(255, 100, 100, 0.5)',
      line: { color: 'black' }
    }
  ];

  // Add recommendation traces
  const colors = ['rgba(100, 150, 255, 0.5)', 'rgba(100, 255, 100, 0.5)', 'rgba(255, 255, 100, 0.5)'];
  const lineColors = ['blue', 'green', 'pink'];

  if (results && results.length > 0) {
    results.slice(0, 3).forEach((food, idx) => {
      const values = categories.map(cat => normalize(food[cat], totalItems));
      data.push({
        type: 'scatterpolar',
        r: values,
        theta: categories,
        fill: 'toself',
        name: `Recommendation ${idx + 1}: ${food['Food Item']}`,
        fillcolor: colors[idx],
        line: { color: lineColors[idx] }
      });
    });
  }

  const layout = {
    polar: {
      radialaxis: {
        visible: true,
        range: [1, 10]
      }
    },
    showlegend: true,
    title: 'Radar Chart for Your Input and Recommendations'
  };

  return (
    <div className="radar-chart-container" ref={containerRef}>
      <div className="radar-chart-header">
        <h2>Your Input and Recommendations Radar Chart</h2>
        {onClose && (
          <button onClick={onClose} className="close-chart-button">×</button>
        )}
      </div>
      <Plot data={data} layout={layout} className="radar-plot" />
    </div>
  );
}

export default RadarChart;

